export type RevenueInsightSegmentationData = Record<string, string | number>;

export type RevenueInsightSegmentationValue = Record<
  string,
  string | RevenueInsightSegmentationData
>;

export type RevenueInsightApiResponse = Record<
  string,
  RevenueInsightSegmentationValue[]
>;

type ExchangeRate = {
  code: string;
  id: string;
};

export type RevenueInsightMultiPropertyApiResponse = {
  exchange_rates: ExchangeRate[];

  remaining_elements: RevenueInsightApiResponse;
  reservations: RevenueInsightApiResponse;
};

export function addIdToSegmentationValueData(
  segmentationValue: RevenueInsightSegmentationValue,
): void {
  Object.keys(segmentationValue).forEach((key) => {
    const segmentationValueKey = segmentationValue[key];
    if (
      segmentationValueKey !== null &&
      !Array.isArray(segmentationValueKey) &&
      typeof segmentationValueKey === 'object'
    ) {
      // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
      segmentationValueKey['id'] = `${segmentationValue['id']}.${key}`;
    }
  });
}

export default function addIdsToSegmentationDataInApiResponse(
  response: RevenueInsightApiResponse,
): void {
  Object.keys(response).forEach((segmentationId) => {
    response[segmentationId]?.forEach((segmentationValue) => {
      addIdToSegmentationValueData(segmentationValue);
    });
  });
}
